import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.6_@babel+core@7.28.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"cyrillic\"],\"variable\":\"--font-inter\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"system-ui\",\"sans-serif\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthHeader"] */ "/app/src/components/auth-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfoProvider"] */ "/app/src/components/user-info-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
